import {
  RecallPermissionKind,
  RecallPermissionMap,
  RecallPermissionStatus,
} from "@/modules/electron/types";

export const DEFAULT_SYSTEM_PERMISSIONS_MAP: RecallPermissionMap = {
  [RecallPermissionKind.ScreenCapture]: RecallPermissionStatus.NotRequested,
  [RecallPermissionKind.Microphone]: RecallPermissionStatus.NotRequested,
  [RecallPermissionKind.Accessibility]: RecallPermissionStatus.NotRequested,
  [RecallPermissionKind.SystemAudio]: RecallPermissionStatus.NotRequested,
  [RecallPermissionKind.FullDiskAccess]: RecallPermissionStatus.NotRequested,
};
